<template>

    <v-row class="fill-height ma-0">
      <v-col :cols="12 - cols" :md="12 - cols" sm="12" class="pa-0 fill-height">
        <v-card variant="flat" class="fill-height">
          <slot name="chart"></slot>
        </v-card>
      </v-col>
      <v-col :cols="cols" :md="cols" sm="12" class="pa-0 border-left-grey fill-height">
        <v-card variant="flat"  class="fill-height">
          <slot name="content"></slot>
        </v-card>
      </v-col>
    </v-row>

</template>

<script>
  import { mapState } from "vuex"

  export default {
    name: "TabTemplate",
    props: {
      cols: {
        type: Number,
        default: 4,
        required: false
      }
    },
    computed: {
      ...mapState('project', {
        drawer: state => state.drawer,
        schematisationDrawer: state => state.schematisationDrawer
      }),
      ...mapState('comment', {
        showComments: state => state.show
      })
    },
    watch: {
      schematisationDrawer () {
        window.dispatchEvent(new Event("resize"))
      },
      drawer () {
        window.dispatchEvent(new Event("resize"))
      },
      showComments () {
        window.dispatchEvent(new Event("resize"))
      }
    },
    mounted () {
      window.dispatchEvent(new Event("resize"))
    }
  }
</script>

<style scoped>
  .border-left-grey {
    border-left-width: 3px;
    border-left-style: solid;
    border-left-color: rgba(0, 0, 0, 0.05);
  }
</style>